exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul.arrow-square[data-v-4287e14d],ul.arrow[data-v-4287e14d],ul.check-circle[data-v-4287e14d],ul.check-square[data-v-4287e14d],ul.check[data-v-4287e14d],ul.chevron[data-v-4287e14d],ul.circle[data-v-4287e14d],ul.decimal[data-v-4287e14d],ul.lower-latin[data-v-4287e14d],ul.triangle[data-v-4287e14d],ul.upper-latin[data-v-4287e14d],ul.upper-roman[data-v-4287e14d]{font-size:1.0833em}@media only screen and (min-device-width:768px) and (max-device-width:1024px){h1[data-v-4287e14d]{font-size:1.6em}.booking-information[data-v-4287e14d]{padding:20px 30px 30px;padding:20px 15px 30px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4287e14d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/infos/covid19/Home.vue
// module id = 574
// module chunks = 0